<template>
  <el-dialog class="dialog-create-plan" :title="pageType==='add' ?'信息发布':'编辑信息发布'" :visible.sync="dialogVisible"
    :before-close="handleBeforeClose" width="850px">
    <div class="wrap">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="制度建设标题 :" prop="title">
          <el-input v-model="form.title" placeholder="请输入"
            :disabled="pageType==='detail' || pageType==='approval'"></el-input>
        </el-form-item>

        <el-form-item label="创建时间 :" prop="title">
          <el-date-picker v-model="form.createTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            placeholder="选择填报时间"></el-date-picker>
        </el-form-item>

        <el-form-item label="内容 :" prop="content">
          <cmp-ckeditor ref="myCkeditor" :defaultMsg="form.content"  :id="`ue1`"
            :height="300"></cmp-ckeditor>
        </el-form-item>

      </el-form>
    </div>

    <div slot="footer" class="footer mt-30" v-if="pageType!=='detail'">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">发布</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate } from '@/utils/util'
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
export default {
  components: {
    cmpUploadProgress,
    cmpCkeditor
  },
  data() {
    // let validateReceiptNumber = (rule, value, callback) => {
    //   if (!validate(value, 'numDecimal')) {
    //     return callback(new Error('最多支持两位小数'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {
      },
      typeList: [],
      dialogVisible: false,
      rules: {
        scope: [
          { required: true, message: '必填', trigger: 'blur' },
          // { min: 1, max: 30, message: '请输入1到30个字符', trigger: 'blur' }
        ],
        title: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      scopeList: [],
    }
  },
  methods: {
    init(type, id) {
      this.dialogVisible = true
      // 清空弹框数据
      this.form = {}
      this.pageType = type // 页面类型
      this.detailId = id || '' // 详情id
      // 新增或编辑
      if (this.detailId) {
        this.getDetailData()
      }
      this.$nextTick(() => {
        this.$refs.myCkeditor.initEditor()
        this.$refs['form'].clearValidate() // 清空验证状态
      })
    },

    // 获取详情
    getDetailData() {
      this.$http
        .get('/bsZdjsWeb/find', {
          informationId: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.form = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },

    // 保存
    fromSubmit(form) {
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (!content) {
        this.$message.warning('请输入内容')
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('/bsZdjsWeb/save', {
              ...this.form,
              content: content
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('信息发布编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('信息发布创建成功')
                }
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },

    handleBeforeClose(done) {
      this.$refs.myCkeditor.setContent('')  // 处理编辑时偶尔不能渲染出富文本数据
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
